/* eslint-disable import/prefer-default-export */

import { useRouter } from 'next/router'
import { useCallback, useEffect } from 'react'

import { OrganizationNavigation } from '../routing'

import { useTimeout } from '~lib/hooks/useTimeout'
import { parseQueryParam } from '~lib/routes'

// Hardcoded way to replicate how back button works in the browsers,
// but redirect to mission control page when you can go back (when user's first page is settings)
// TODO - fix it by implementing inner history in the application
export function useBackButtonClick() {
  const router = useRouter()
  const organizationSlug = parseQueryParam(router.query, 'organizationSlug')

  const { setTimeout, clearTimeouts } = useTimeout()

  const handleBackClick = useCallback(() => {
    router.back()

    // Redirect to mission control if user is on the last page in the history and back button does nothing
    setTimeout(() => {
      router.push({
        pathname: OrganizationNavigation.organization.missionControlPM.route.pathname,
        query: { organizationSlug },
      })
    }, 500)
  }, [organizationSlug, router, setTimeout])

  useEffect(() => {
    function callback() {
      clearTimeouts()
    }

    // When the user presses the back button and the route starts to change, we clear the redirect to the mission control timeout.
    router.events.on('routeChangeStart', callback)

    return () => {
      router.events.off('routeChangeStart', callback)
    }
  }, [clearTimeouts, router.events])

  return handleBackClick
}
